import { Breadcrumbs, Button, Paper, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { db } from '../../firebase';
import { Editor, EditorTools } from "@progress/kendo-react-editor";
import "@progress/kendo-theme-default/dist/all.css";
import { Alert } from '@mui/material';
const {
  Bold,
  Italic,
  Underline,
  Strikethrough,
  Subscript,
  Superscript,
  ForeColor,
  BackColor,
  CleanFormatting,
  AlignLeft,
  AlignCenter,
  AlignRight,
  AlignJustify,
  Indent,
  Outdent,
  OrderedList,
  UnorderedList,
  NumberedList,
  BulletedList,
  Undo,
  Redo,
  FontSize,
  FontName,
  FormatBlock,
  Link,
  Unlink,
  InsertImage,
  ViewHtml,
  InsertTable,
  InsertFile,
  SelectAll,
  Print,
  Pdf,
  AddRowBefore,
  AddRowAfter,
  AddColumnBefore,
  AddColumnAfter,
  DeleteRow,
  DeleteColumn,
  DeleteTable,
  MergeCells,
  SplitCell,
} = EditorTools;

const tools = [
  [Bold, Italic, Underline, Strikethrough],
  [Subscript, Superscript],
  ForeColor,
  BackColor,
  [CleanFormatting],
  [AlignLeft, AlignCenter, AlignRight, AlignJustify],
  [Indent, Outdent],
  [OrderedList, UnorderedList],
  [NumberedList, BulletedList],
  FontSize,
  FontName,
  FormatBlock,
  [SelectAll],
  [Undo, Redo],
  [Link, Unlink, InsertImage, ViewHtml],
  [InsertTable, InsertFile],
  [Pdf, Print],
  [AddRowBefore, AddRowAfter, AddColumnBefore, AddColumnAfter],
  [DeleteRow, DeleteColumn, DeleteTable],
  [MergeCells, SplitCell],
];

function OtherTemp({back, type}) {
   const [msg, setMsg] = React.useState(null);
   const [editorValue, setEditorValue] = useState("");

  const handleSubmit = e => {
    e.preventDefault();
    db.collection('temp').doc(type).delete()
    db.collection('temp').doc(type).set({
            desc: `${editorValue}`
        })
    setMsg('Saved successfully')
  };


    useEffect(() => {
     db.collection('temp').doc(type).get().then((snapshot)=>{
        let data = snapshot.data().desc
        setEditorValue(data)
     })
    }, [])
    
  return (
    <div>
     <Breadcrumbs aria-label="breadcrumb" style={{background:'white',padding:'1rem',width:'fit-content'}}>
  <a underline="always" onClick={back} style={{cursor:'pointer',color:'blue'}}>
    Templates
  </a>
  <Typography color="text.primary">{type=='feedback'? 'Feedback': 'Acknowledgement'} Templates</Typography>
</Breadcrumbs>

    <Paper style={{padding:'1rem'}}>
    <div className="k-flex-grow" style={{ maxWidth: "100%" }}>
         {msg ? (
                    <Alert onClose={() => {setMsg('')}} severity="success">
                       {msg} 
                    </Alert>
                ) : null}
          <form onSubmit={handleSubmit}>
            <Editor
              tools={tools}
              contentStyle={{ height: 200,width:'100%' }}
              onChange={(event) => setEditorValue(event.html)}
              value={editorValue}
            />
            <a style={{color:'red'}}>No more than 500 words</a>
          </form>
          <Button variant='contained' type='submit' onClick={handleSubmit}>Save</Button>
        </div>
    </Paper>
    </div>
  )
}

export default OtherTemp